// hooks/useAtualizarDados.ts
import { useState } from "react";
import { cadastrarParceiro } from "../../../services/cadastrarParceiroService";
import { Parceiro } from "../../../interfaces/Parceiro";

export const useCadastrarParceiro = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (parceiroData: Parceiro) => {
    setIsLoading(true);
    setError(null);

    try {
      const cadastrarDados = await cadastrarParceiro(parceiroData);

      if (cadastrarDados) {
        setSuccess("Parceiro cadastrado com sucesso!");
      } else {
        setError(
          "Não foi possível cadastrar o parceiro, por favor tente novamente!"
        );
      }
    } catch (error) {
      setError(`Não foi possível cadastrar o parceiro,${error}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
